import api from './api';

/**
 * @param {string} user_id
 */
export default async function getUserResults(user_id) {
    const { data } = await api.get('/users_results', {
        params: {
            user_id
        }
    });

    return data;
}